/* 
 * This is normal button but it hides if the user doesn't have action permission
 */

/* global customElements */
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

class ActionButton extends BaseComponent {
	
	static get properties() {
		return {	
			menu: {type: Array},
			theme: {type: String},
			disabled: {type: Boolean},
			eclass: {type: String},
			style: {type: String}
		};
	}
	
	constructor() {
		super();	
		
		this.menu = [];
		this.theme = '';
		this.disabled = false;
		this.eclass = '';
		this.style = '';
				
		var actionButton = this;
		actionButton.addEventListener('click', function (event) {
			if (actionButton.disabled) {
				event.stopImmediatePropagation();
				event.stopPropagation();
				event.preventDefault();							
			}
		});	
		
		setTimeout(function(){
			actionButton.init();
		});
	}
	
	render() {	
		return html`
			<style>
				.hide {
					display: none;
				}
			</style>
			<vaadin-button itemid='button' style='${this.style}' class='${this.eclass}' theme="${this.theme}" ?disabled=${this.disabled}>
				<slot></slot>
			</vaadin-button>
		`;
	}
	
	init() {
		var actionButtonFull = this;
	
		customElements.whenDefined('vaadin-button').then(function() {
			var actionButton = ElementUtil.query(actionButtonFull, 'button');

			if (actionButtonFull.menu && actionButtonFull.menu.length > 0) {
				var menu = ElementUtil.create({
					tag: 'vaadin-list-box',
					itemid: 'menu',
					'class': 'button-menu hide',
					children: actionButtonFull.menu
				});

				actionButtonFull.append(menu);
				actionButton.append(
					ElementUtil.create({
						tag: 'vaadin-icon',
						icon: 'vaadin:caret-down',
						slot: 'suffix'
					})
				);

				actionButton.addEventListener('click', function (event) {
					if (ElementUtil.query(actionButtonFull, 'menu')) {
						ElementUtil.query(actionButtonFull, 'menu').classList.toggle('hide');

						event.stopPropagation();
						event.preventDefault();
					} else {
						menu.classList.toggle('hide');
					}
				});

				document.addEventListener('click', function () {
					if (!menu.classList.contains('hide')) {
						menu.classList.toggle('hide');
					}
				});
			}
			
	
			actionButton.classList.add('hide');
			Service.getUserService().getCurrentUser().then(function (user) {

				var valid = false;
				if (actionButtonFull.getAttribute('permissions')) {
					var permissions = actionButtonFull.getAttribute('permissions').split(',');
					var permissionOp = actionButtonFull.getAttribute('permission-op') || 'OR';


					if (permissions) {
						if (permissionOp === 'OR') {
							var haveCount = 0;
							permissions.forEach(function (permission) {
								if (user.hasPermission(permission)) {
									haveCount++;
								}
							});
							if (haveCount > 0) {
								valid = true;
							}
						} else {
							var haveCount = 0;
							permissions.forEach(function (permission) {
								if (user.hasPermission(permission)) {
									haveCount++;
								}
							});
							if (haveCount === permissions.length) {
								valid = true;
							}
						}
					} else {
						valid = true;
					}
				} else {
					valid = true;
				}


				if (valid) {
					actionButton.classList.remove('hide');
				}

			});	
		});
	}
	
	
};
customElements.define('dl-action-button', ActionButton);


